import React from "react";
import {
  RiUserSearchLine,
  RiSettings3Line,
  RiHistoryLine,
} from "react-icons/ri";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { useAdminController } from "./useAdminController";
import { NotAuthorized } from "./components/NotAuthorized";
import { AdminHeader } from "./components/AdminHeader";
import { Users } from "./users/Users";
import { Settings } from "./settings/Settings";
import { Audit } from "./audit/Audit";

export const Admin = () => {
  const controller = useAdminController();

  if (!controller.isUserAdmin) {
    return <NotAuthorized />;
  }

  return (
    <div className="container py-8 max-w-4xl">
      <div className="flex flex-col space-y-8">
        <AdminHeader />

        <Tabs
          value={controller.activeTab}
          onValueChange={controller.setActiveTab}
          className="space-y-4"
        >
          <TabsList className="grid w-full grid-cols-3">
            <TabsTrigger value="users" className="flex items-center gap-2">
              <RiUserSearchLine className="h-4 w-4" />
              <span>Users</span>
            </TabsTrigger>
            <TabsTrigger value="audit" className="flex items-center gap-2">
              <RiHistoryLine className="h-4 w-4" />
              <span>Audit</span>
            </TabsTrigger>
            <TabsTrigger value="settings" className="flex items-center gap-2">
              <RiSettings3Line className="h-4 w-4" />
              <span>Settings</span>
            </TabsTrigger>
          </TabsList>

          <div className="rounded-xl p-6 border bg-card">
            <TabsContent value="users" className="mt-0">
              <Users />
            </TabsContent>
            <TabsContent value="audit" className="mt-0">
              <Audit />
            </TabsContent>
            <TabsContent value="settings" className="mt-0">
              <Settings />
            </TabsContent>
          </div>
        </Tabs>
      </div>
    </div>
  );
};
